'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _getSize = require('../../../helpers/getSize');

var _getSize2 = _interopRequireDefault(_getSize);

var _sizes = require('../../../constants/sizes');

var _colors = require('../../../constants/colors');

var _layout = require('../layout');

var _layout2 = _interopRequireDefault(_layout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DefaultIcon = function DefaultIcon(props) {
    return _react2.default.createElement(
        'svg',
        props,
        _react2.default.createElement(
            'defs',
            null,
            _react2.default.createElement('path', {
                id: 'a',
                d: 'M0 .9h57.192v60.022H0z'
            }),
            _react2.default.createElement('path', {
                id: 'c',
                d: 'M0 60.959h57.193V.938H0z'
            })
        ),
        _react2.default.createElement(
            'g',
            {
                transform: 'translate(1 -1)',
                fill: 'none',
                fillRule: 'evenodd'
            },
            _react2.default.createElement(
                'g',
                {
                    transform: 'translate(0 .037)'
                },
                _react2.default.createElement(
                    'mask',
                    {
                        id: 'b',
                        fill: '#fff'
                    },
                    _react2.default.createElement('use', {
                        xlinkHref: '#a'
                    })
                ),
                _react2.default.createElement('path', {
                    d: 'M39.513 54.396H6.836V7.46h2.54v25.177c0 3.984 3.228 7.223 7.2 7.235H39.513v14.523zm-4.965 4.651H1.87V12.113h3.095V56.27h29.583v2.777zm9.473-26.83H21.08v1.563c0 1.72-1.046 3.275-2.603 3.87a5.282 5.282 0 0 1-1.893.348c-2.944-.007-5.337-2.407-5.337-5.36V2.774H44.02v29.443zM51.22 38H21.252a6.091 6.091 0 0 0 1.69-3.907h32.372c-.127 2.114-1.771 3.805-3.852 3.902a5.066 5.066 0 0 1-.241.005zm-5.33-5.782V.9H9.377v4.686h-4.41v4.653H0v50.683h36.419V56.27h4.965V39.874h9.837c.113 0 .223-.002.33-.008 3.164-.146 5.641-2.796 5.641-6.036v-1.613h-11.3z',
                    fill: '#3F5060',
                    mask: 'url(#b)'
                })
            ),
            _react2.default.createElement(
                'mask',
                {
                    id: 'd',
                    fill: '#fff'
                },
                _react2.default.createElement('use', {
                    xlinkHref: '#c'
                })
            ),
            _react2.default.createElement('path', {
                fill: '#00D8C8',
                mask: 'url(#d)',
                d: 'M17.52 12.2h20.488v-1.874H17.52zM17.52 15.943h20.488V14.07H17.52zM17.52 19.685h20.488V17.81H17.52zM17.52 23.426h20.488v-1.874H17.52zM31.605 26.23v-.937H17.519v1.875h14.086z'
            }),
            _react2.default.createElement('path', {
                fill: '#FFCF3F',
                mask: 'url(#d)',
                d: 'M12.235 45.943h20.487V44.07H12.235zM12.235 49.685h15.81v-1.874h-15.81z'
            })
        )
    );
};

DefaultIcon.defaultProps = {
    width: '60',
    height: '60',
    viewBox: '0 0 60 60',
    xmlns: 'http://www.w3.org/2000/svg',
    xmlnsXlink: 'http://www.w3.org/1999/xlink'
};

var ProfileIcon = function (_React$Component) {
    _inherits(ProfileIcon, _React$Component);

    function ProfileIcon() {
        _classCallCheck(this, ProfileIcon);

        return _possibleConstructorReturn(this, (ProfileIcon.__proto__ || Object.getPrototypeOf(ProfileIcon)).apply(this, arguments));
    }

    _createClass(ProfileIcon, [{
        key: 'render',
        value: function render() {
            var size = this.props.size || _sizes.Sizes.md;
            size = (0, _getSize2.default)(size);
            return _react2.default.createElement(
                _layout2.default,
                this.props,
                _react2.default.createElement(DefaultIcon, { fill: this.props.hover || this.props.active ? _colors.Colors.calmWhite : _colors.Colors.claimBlack, width: size + 'px', height: size + 'px' })
            );
        }
    }]);

    return ProfileIcon;
}(_react2.default.Component);

exports.default = ProfileIcon;